(function (root) {
  var PALETTE_GWP = 'Palette Builder Free Well';
  var queue = Promise.resolve();
  var pendingAutoAdds = {};

  function offers() {
    return Array.isArray(root.gwpTierOffers) ? root.gwpTierOffers : [];
  }

  function hasGiftProperty(item) {
    return Boolean(item && item.properties && (item.properties._GWP || item.properties._is_auto_GWP));
  }

  function isPaletteGift(item) {
    return Boolean(item && item.properties && item.properties._GWP === PALETTE_GWP);
  }

  function isManagedGift(item) {
    return hasGiftProperty(item) && !isPaletteGift(item);
  }

  function offerByHandle(handle) {
    return offers().find(function (offer) {
      return offer.handle === handle;
    }) || null;
  }

  function offerForLine(item) {
    if (!item || !item.properties) return null;
    if (item.properties._GWP && item.properties._GWP !== PALETTE_GWP) {
      return offerByHandle(item.properties._GWP);
    }
    if (item.properties._is_auto_GWP) {
      var variantId = Number(item.variant_id);
      var productId = Number(item.product_id);
      return offers().find(function (offer) {
        var variants = offer.variantIds || [];
        var products = offer.productIds || [];
        return variants.map(Number).indexOf(variantId) !== -1 || products.map(Number).indexOf(productId) !== -1;
      }) || null;
    }
    return null;
  }

  function tierAmount(item) {
    if (!isManagedGift(item)) return null;
    var offer = offerForLine(item);
    if (offer) return Number(offer.minAmount) || 0;
    // Product-triggered auto gifts that are not spend-tier offers have no tier amount.
    return null;
  }

  function paidSubtotal(cart) {
    if (!cart) return 0;
    var giftValue = (cart.items || []).reduce(function (sum, item) {
      if (!hasGiftProperty(item)) return sum;
      return sum + (Number(item.final_line_price) || 0);
    }, 0);
    var subtotal = Number(cart.items_subtotal_price);
    if (!Number.isFinite(subtotal)) {
      subtotal = (cart.items || []).reduce(function (sum, item) {
        return sum + (Number(item.final_line_price) || 0);
      }, 0);
    }
    return Math.max(0, subtotal - giftValue);
  }

  function offerIsBlocked(handle) {
    if (!handle || typeof document === 'undefined' || !document.querySelectorAll) return false;
    var nodes = document.querySelectorAll('[data-gwp="' + String(handle).replace(/"/g, '') + '"][js-gwp-case]');
    if (!nodes.length) return false;
    var unlocked = false;
    nodes.forEach(function (node) {
      if (!node.hasAttribute('disabled') && node.dataset.unlocked !== 'false') unlocked = true;
    });
    return !unlocked;
  }

  function linesToRemove(cart) {
    var catalog = offers();
    var items = (cart && cart.items) || [];
    if (!catalog.length) return [];

    var paid = paidSubtotal(cart);
    var paidItemCount = items.filter(function (item) {
      return !hasGiftProperty(item);
    }).length;
    var managed = [];

    items.forEach(function (item) {
      if (!isManagedGift(item)) return;
      var offer = offerForLine(item);
      // Standalone product auto-adds are owned by auto-add-gwp.js, not spend-tier cleanup.
      if (!offer && item.properties && item.properties._is_auto_GWP) return;
      var amount = tierAmount(item);
      var blocked = offer ? offerIsBlocked(offer.handle) : false;
      managed.push({ item: item, amount: amount, blocked: blocked });
    });

    var winning = null;
    managed.forEach(function (entry) {
      if (entry.amount === null || entry.blocked || paid < entry.amount) return;
      if (winning === null || entry.amount > winning) winning = entry.amount;
    });

    var remove = [];
    managed.forEach(function (entry) {
      var drop = entry.amount === null || entry.blocked || paid < entry.amount;
      if (!drop && winning !== null && entry.amount < winning) drop = true;
      if (!drop && paidItemCount === 0) drop = true;
      if (drop) remove.push(entry.item);
    });
    return remove;
  }

  function winningAmount(cart) {
    var paid = paidSubtotal(cart);
    var winning = null;
    ((cart && cart.items) || []).forEach(function (item) {
      var amount = tierAmount(item);
      if (amount === null || paid < amount) return;
      if (offerForLine(item) && offerIsBlocked(offerForLine(item).handle)) return;
      if (winning === null || amount > winning) winning = amount;
    });
    return winning;
  }

  root.gwpLineMatchesOffer = function (handle, item) {
    var offer = offerByHandle(handle);
    if (!offer || !item) return false;
    var variantId = Number(item.variant_id);
    var productId = Number(item.product_id);
    return (offer.variantIds || []).map(Number).indexOf(variantId) !== -1
      || (offer.productIds || []).map(Number).indexOf(productId) !== -1;
  };

  root.gwpCartRules = {
    isManagedGift: isManagedGift,
    paidSubtotal: paidSubtotal,
    tierAmount: tierAmount,
    offerForLine: offerForLine,
    linesToRemove: linesToRemove,
    winningAmount: winningAmount,
    isAutoAddPending: function (variantId) {
      return Boolean(pendingAutoAdds[Number(variantId)]);
    }
  };

  function fetchCart() {
    var rootUrl = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
    return fetch(rootUrl + 'cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
      .then(function (response) { return response.json(); });
  }

  function dedupeItems(items) {
    var seen = {};
    return items.filter(function (item) {
      if (!item || !item.key || seen[item.key]) return false;
      seen[item.key] = true;
      return true;
    });
  }

  function refreshCart(response) {
    try {
      var page = document.querySelector('cart-items[data-page="true"]');
      if (page && typeof page.onCartUpdate === 'function') {
        page.onCartUpdate();
        return;
      }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && response && response.sections) {
        drawer.renderContents(response);
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (error) {
      console.error(error);
    }
  }

  function sectionsToRender() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (section) { return section.id; });
    }
    return ['cart', 'cart-count'];
  }

  function applyUpdates(updates) {
    var updateUrl = (root.routes && root.routes.cart_update_url) || '/cart/update';
    if (updateUrl.slice(-3) !== '.js') updateUrl += '.js';
    return fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sectionsToRender() })
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (!response || response.status) return response;
        refreshCart(response);
        return response;
      });
  }

  function applyRemovals(items) {
    var updates = {};
    items.forEach(function (item) {
      updates[item.key] = 0;
    });
    return applyUpdates(updates);
  }

  function applyClamps(clamps) {
    var updates = {};
    clamps.forEach(function (entry) {
      if (!entry || !entry.key) return;
      updates[entry.key] = Math.max(0, Number(entry.quantity) || 0);
    });
    if (!Object.keys(updates).length) return Promise.resolve();
    return applyUpdates(updates);
  }

  function applyAdditions(items) {
    if (!items || !items.length) return Promise.resolve();
    items.forEach(function (item) {
      pendingAutoAdds[Number(item.id)] = true;
    });
    var rootUrl = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
    return fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionsToRender() })
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (!response || response.status) {
          if (response && response.description) console.error(response.description);
          return response;
        }
        refreshCart(response);
        return response;
      })
      .finally(function () {
        items.forEach(function (item) {
          delete pendingAutoAdds[Number(item.id)];
        });
      });
  }

  function reconcile() {
    return fetchCart().then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      var removals = linesToRemove(cart);
      var additions = [];
      var clamps = [];
      if (typeof root.collectAutoGwpChanges === 'function') {
        var autoChanges = root.collectAutoGwpChanges(cart, removals) || {};
        if (autoChanges.remove) removals = removals.concat(autoChanges.remove);
        if (autoChanges.add) additions = autoChanges.add;
        if (autoChanges.clamp) clamps = autoChanges.clamp;
      }
      removals = dedupeItems(removals);
      if (removals.length) return applyRemovals(removals);
      if (clamps.length) return applyClamps(clamps);
      if (additions.length) return applyAdditions(additions);
    });
  }

  root.purgeIneligibleGwps = function () {
    var run = queue.then(reconcile, reconcile);
    queue = run.then(function () {}, function (error) {
      console.error(error);
    });
    return run;
  };
})(typeof window !== 'undefined' ? window : globalThis);
